import base from "./base.service";

const getChatsList = payload => base.get('/chats/list', { params: payload });

const getMessages = payload => base.get('/chats/messages', { params: payload });

const startChat = payload => base.post('/chats/startChat', payload);

export const chatService = {
    getMessages,
    getChatsList,
    startChat
};